import {
    useTranslate,
    IResourceComponentsProps,
    CrudFilters,
    HttpError,
} from "@pankod/refine-core";

import {
    List,
    Table,
    // Avatar,
    useTable,
    // DateField,
    // BooleanField,
    Card,
    CreateButton,
    Input,
    Icons,
    Form,
    DatePicker,
    Button,
    NumberField,
    // Select,
    // FilterDropdown,
    FormProps,
    Row,
    Col,
    // ShowButton,
    EditButton,
    // useSelect,
    useDrawerForm,
} from "@pankod/refine-antd";

// import { IUser, IUserFilterVariables } from "../../interfaces";
import { IRoom, IUserFilterVariables } from "interfaces";

import { CreateRoom, EditRoom } from "components/room";
import { RoomStatus } from "components/roomStatus";
import { RoomLocation } from "components/roomLocation";

export const RoomList: React.FC<IResourceComponentsProps> = () => {
  const { tableProps, searchFormProps } = useTable<
    IRoom,
    HttpError,
    IUserFilterVariables
  >({
    resource: "rooms",
    initialSorter: [{
      field: "title",
      order: "asc",
    }],
    metaData: {
      select: "*",
      // select: "*, organizations:organization_id(title)",
    },
    onSearch: (params) => {
      const filters: CrudFilters = [];
      const { q, created_at } = params;

      if (q) {
        filters.push({
          field: "title",
          operator: "contains",
          value: q,
        });
      }

      filters.push(
        {
          field: "created_at",
          operator: "gte",
          value: created_at
            ? created_at[0].startOf("day").toISOString()
            : undefined,
        },
        {
          field: "created_at",
          operator: "lte",
          value: created_at
            ? created_at[1].endOf("day").toISOString()
            : undefined,
        },
      );

      return filters;
    },
    syncWithLocation: false,
  });

  const t = useTranslate();

  const {
    drawerProps: createDrawerProps,
    formProps: createFormProps,
    saveButtonProps: createSaveButtonProps,
    show: createShow,
  } = useDrawerForm<IRoom>({
    action: "create",
    resource: "rooms",
    redirect: false,
  });

  const {
    drawerProps: editDrawerProps,
    formProps: editFormProps,
    saveButtonProps: editSaveButtonProps,
    show: editShow,
  } = useDrawerForm<IRoom>({
    action: "edit",
    resource: "rooms",
    redirect: false,
  });

  // const { selectProps } = useSelect<IOrganization>({
  //   resource: "organizations",
  // });

  return (
    <>
      <Row gutter={[16, 16]}>
        <Col xl={6} lg={24} xs={24}>
          <Card title={t("users.filter.title")}>
            <Filter formProps={searchFormProps} />
          </Card>
          {/* <CreateButton onClick={() => createShow()}> {t("stores.buttons.addProduct")}</CreateButton> */}
        </Col>
        <Col xl={18} xs={24}>
          <List pageHeaderProps={{ extra: <CreateButton onClick={() => createShow()}> {t("rooms.titles.create")}</CreateButton> }}>
            <Table {...tableProps} rowKey="id">
              <Table.Column
                key="title"
                dataIndex="title"
                title={t("rooms.fields.title")}
              />
              <Table.Column
                key="code"
                dataIndex="code"
                title={t("rooms.fields.code")}
              />
              <Table.Column
                dataIndex="status"
                title={t("rooms.fields.status")}
                render={(value) => {
                  return <RoomStatus status={value} />;
                }}
              />
              {/* <Table.Column
                key="isActive"
                dataIndex="isActive"
                title={t("users.fields.isActive.label")}
                render={(value) => <BooleanField value={value} />}
              /> */}
              <Table.Column
                key="location"
                dataIndex="location"
                title={t("rooms.fields.location")}
                render={(value) => {
                  return <RoomLocation status={value} />;
                }}
                // sorter
              />
              <Table.Column
                key="area"
                dataIndex="area"
                title={t("rooms.fields.area")}
                sorter
              />
              <Table.Column
                align="right"
                key="price_area"
                dataIndex="price_area"
                title={t("rooms.fields.priceArea")}
                render={(value) => {
                  return (
                    <NumberField
                      options={{
                        currency: "UAH",
                        style: "currency",
                      }}
                      // value={value / 100}
                      value={value}
                    />
                  );
                }}
              />
              <Table.Column
                align="right"
                key="price"
                dataIndex="price"
                title={t("rooms.fields.price")}
                render={(value) => {
                  return (
                    <NumberField
                      options={{
                        currency: "UAH",
                        style: "currency",
                      }}
                      // value={value / 100}
                      value={value}
                    />
                  );
                }}
              />
              <Table.Column<IRoom>
                title={t("table.actions")}
                render={(_, record) => (
                  <EditButton hideText onClick={() => editShow(record.id)} />
                )}
              />
            </Table>
          </List>
        </Col>
      </Row>
      <CreateRoom drawerProps={createDrawerProps} formProps={createFormProps} saveButtonProps={createSaveButtonProps} />
      <EditRoom drawerProps={editDrawerProps} formProps={editFormProps} saveButtonProps={editSaveButtonProps} />
    </>
  );
};

const Filter: React.FC<{ formProps: FormProps }> = (props) => {
  const t = useTranslate();

  const { RangePicker } = DatePicker;

  return (
        <Form layout="vertical" {...props.formProps}>
          <Row gutter={[10, 0]} align="bottom">
            <Col xs={24} xl={24} md={12}>
              <Form.Item label={t("users.filter.search.label")} name="q">
                <Input
                  placeholder={t("users.filter.search.placeholder")}
                  prefix={<Icons.SearchOutlined />}
                />
              </Form.Item>
            </Col>
            <Col xs={24} xl={24} md={12}>
                    <Form.Item
                        label={t("users.filter.createdAt.label")}
                        name="created_at"
                    >
                        <RangePicker style={{ width: "100%" }} />
                    </Form.Item>
            </Col>
              {/* <Col xs={24} xl={24} md={8}>
                  <Form.Item
                      label={t("users.filter.gender.label")}
                      name="gender"
                  >
                    <Select
                      allowClear
                      placeholder={t("users.filter.gender.placeholder")}
                      options={[
                        {
                          label: t("users.filter.gender.male"),
                          value: "Male",
                        },
                        {
                          label: t("users.filter.gender.female"),
                          value: "Female",
                        },
                      ]}
                    />
                    </Form.Item>
              </Col> */}
                {/* <Col xs={24} xl={24} md={8}>
                    <Form.Item
                        label={t("users.filter.isActive.label")}
                        name="isActive"
                    >
                        <Select
                            allowClear
                            placeholder={t("users.filter.isActive.placeholder")}
                            options={[
                                {
                                    label: t("users.filter.isActive.true"),
                                    value: "true",
                                },
                                {
                                    label: t("users.filter.isActive.false"),
                                    value: "false",
                                },
                            ]}
                        />
                    </Form.Item>
                </Col> */}
                <Col xs={24} xl={24} md={8}>
                    <Form.Item>
                        <Button
                            style={{ width: "100%" }}
                            htmlType="submit"
                            type="primary"
                        >
                            {t("users.filter.submit")}
                        </Button>
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    );
};
